var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 14,
    viewBox: "0 0 381 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.199 7.13911C332.195 5.77246 338.93 8.33492 287.58 3.85062C213.991 -1.74407 217.788 18.9264 181.445 9.18906C152.47 1.33087 148.493 -2.72635 118.252 5.60162C91.1309 14.2285 90.7693 16.6629 25 5.5162",
    stroke: "url(#paint0_linear_53_254)",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.199 7.13911C308.195 5.77246 314.93 8.33492 263.58 3.85062C189.991 -1.74407 193.788 18.9264 157.445 9.18906C128.47 1.33087 124.493 -2.72635 94.2523 5.60162C67.1309 14.2285 66.7693 16.6629 0.999999 5.5162",
    stroke: "url(#paint1_linear_53_254)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_254",
    x1: 380.199,
    y1: 7,
    x2: 25,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6347",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_254",
    x1: 356.199,
    y1: 7,
    x2: 1,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6347",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37);
export default __webpack_public_path__ + "static/media/Group37.cf61ee453a67e896a50cb6172c75c340.svg";
export { ForwardRef as ReactComponent };